import "./instrument.js"
import ReactDOM from "react-dom"
import "./i18n.js"
import Shell from "./Shell.jsx"

ReactDOM.render(<Shell />, document.getElementById("app"))
